'use strict';

module.exports = function loadUnaggregatedEnvelopes(pageState, s3FileModel, fromChangeKey) {
	if (!pageState || !s3FileModel) {
		throw new Error('invalid-args');
	}
	const pathInfo = pageState.getPathInfo();
	if (pathInfo && pathInfo.goldFileShare) {
		return Promise.resolve([]);
	}
	return s3FileModel.unaggregatedChanges(pathInfo, {fromChangeKey: fromChangeKey})
	.then((unaggregatedChanges) => {
		if (!unaggregatedChanges) {
			return [];
		}
		let envelopes = [];
		if (unaggregatedChanges.content && unaggregatedChanges.content.length) {
			envelopes = envelopes.concat(unaggregatedChanges.content);
		}
		if (unaggregatedChanges.ommittedFiles) {
			return loadUnaggregatedEnvelopes(pageState, s3FileModel, unaggregatedChanges.lastFileKey)
			.then((loaded) => {
				return envelopes.concat(loaded);
			});
		}
		return envelopes;
	});
};
